import React from 'react';
import '../stylesheets/footer.css'

export default function Footer() {
  return (
    <section className='footer'>
      <p>Randy Sartor 2019 <span><i className="devicon-react-original colored"></i></span> I made this portfolio using React</p>
    </section>
  )
}